import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useLogout } from '@digiwedge/hooks-auth-web';
import { ContentWrap } from '../components/ContentWrap.js';
import { PageContent } from '../components/PageContent.js';
import { getMessage } from '../i18n/messages.js';
import { toast } from '../utils/toast.js';
export const LogoutPage = () => {
    const { logout } = useLogout();
    const navigate = useNavigate();
    useEffect(() => {
        const performLogout = async () => {
            try {
                await logout();
                toast.success(getMessage('en-US', 'logoutSuccess'));
            }
            catch {
                toast.error(getMessage('en-US', 'logoutError'));
            }
            finally {
                navigate('/login');
            }
        };
        performLogout();
    }, [logout, navigate]);
    return (_jsx(PageContent, { children: _jsx(ContentWrap, { className: "flex items-center justify-center", children: _jsxs("div", { className: "flex flex-col items-center", children: [_jsx("div", { "aria-label": getMessage('en-US', 'logoutProgress'), className: "h-8 w-8 animate-spin rounded-full border-4 border-gray-300 border-t-blue-500" }), _jsx("p", { className: "mt-2 text-gray-700", children: getMessage('en-US', 'logoutProgress') })] }) }) }));
};
//# sourceMappingURL=LogoutPage.js.map